// startup
// Load entry module and return exports
__webpack_require__(47920);
// This entry module used 'module' so it can't be inlined
let __webpack_exports__ = __webpack_require__(10830);
